<template>
      <fiche-header :ressource="ressource"
                    @back="back"
                    @openAll="openAll"
                    @closeAll="closeAll">
      </fiche-header>
  <div class="fiche">
    <!-- Liste des sections de la fiche -->
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('CONTRAT_VIEWER')">
        <slot name="section-contrat-viewer">
          <section-contrat-viewer ref="CONTRAT_VIEWER"
                                  id="CONTRAT_VIEWER"
                                  :extended="isExtended('CONTRAT_VIEWER')"
                                  :showButton="true"
                                  :autoSave="true"
                                  :readOnly="readOnly"
                                  :moduleId="moduleId"
                                  :searchText="searchText"
                                  :ressourceHeader="ressource"
                                  :fiche="fiche"
                                  :contrat=selectedContrat
                                  :route="route"
                                  :attribut="attribut"
                                  @extended="setExtended"
                                  @fullscreen="setFullscreen"
                                  @status="updateStatus"
                                  @updated="contratUpdated"
                                  @selectItem = "selectItem">
          </section-contrat-viewer>
        </slot>
    </v-col>
  </div>
</template>
<script lang="ts">
import { defineComponent, type PropType } from "vue";
import FicheBase from '@/framework/base/components/FicheBase';
import Route from '@/extend/classes/Route';
import { CiRouter } from '@/framework/base/helpers/NavHelper'
import { Fiches } from '@/generated/classes/AppSchema';
import { Extended } from '@/framework/base/classes/Schema';
import Contrat from '@/extend/classes/Contrat';
import FicheHeader from '@/framework/base/components/FicheHeader.vue';
import { GenFiche, RessourceGenFiche } from '@/generated/ressources/generatedRessources';
import SectionContratViewer from '@/custom/sections/SectionContratViewer.vue';

export default defineComponent({
  extends: FicheBase,
  components: {
    SectionContratViewer,
    FicheHeader,
  },

  props: {
    contrat: {
      type: Object as PropType<Contrat>,
    },
  },

  created (): void {
    this.addFiches(this.sections);
  },

  data() {
    return {
      moduleId: 0,
      fiche: Fiches.CONTRAT_VIEWER,
      sections: [
        'CONTRAT_VIEWER',
      ],

    }
  },

  computed: {
    ressource () {
      return RessourceGenFiche(GenFiche.FICHE_CONTRAT_VIEWER);
    },

    selectedContrat (): Contrat {
      return this.contrat
    },
  },
  methods: {
    ficheMounted () {
      this.onShowSectionChanged();
      this.setFocus();
    },

    setFocus (): void {
      if (this.isMounted) {
        let res = false;
        let first = '';
        const route = CiRouter.getRoute();
        const notifSection = route ? route.section : '';
        this.sections.forEach(section => {
          // @ts-expect-error : generated method
          if (this.isDisplayed(section) && this.$refs[section] && this.$refs[section].allReadOnly && this.$refs[section].setFocus) {
            if (notifSection == section) {
              // @ts-expect-error : generated method
              this.$refs[section].setFocus(route);
              res = true;
            } else if (first == '') {
              first = section;
            }
          }
        })
        if (!res && first != '' && this.$refs[first]) {
          // @ts-expect-error : generated method
          this.$refs[first].setFocus(route);
        }
      }
    },

    // eslint-disable-next-line
    contratUpdated (contrat: Contrat) {
    // To implement
    },

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isDisplayed (value: string): boolean {
      if ((!this.contrat || this.contrat.id < 0) && value == 'CONTRAT_VIEWER') {
        this.setExtended(new Extended('CONTRAT_VIEWER', this.fiche, true));
      }
      return true;
    }
  }
})
</script>
